<template>
  <div id="footer-content">
    <div class="foot-main">
      <div class="foot-box clearfix">
        <div class="fl fm01">
          <div class="foot-logo"></div>
          <h5>游戏忠告：</h5>
          <p>
            抵制不良游戏，拒绝盗版游戏。
            <br />注意自我保护，谨防受骗上当。
            <br />适度游戏益脑，沉迷游戏伤身。
            <br />合理安排时间，享受健康生活。
          </p>
        </div>
        <div class="fl fm02">
          <div class="foot-menu clearfix">
            <dl>
              <dt>中青宝云游戏</dt>
              <dd>
                <a @click="$router.push('/client')">客户端</a>
                <a @click="$router.push('/recharge')">充值</a>
                <a @click="$router.push('/aboutus')">关于我们</a>
                <!-- <a href='/client'>客户端</a>
                <a href='/recharge'>充值</a>
                <a href='/aboutus'>关于我们</a>-->
              </dd>
            </dl>
            <dl>
              <dt>合作</dt>
              <dd>
                <a @click="$router.push('/Paas')">PaaS平台</a>
                <a @click="$router.push('/Iaas')">IaaS 平台</a>
                <a @click="$router.push('/jubao')">聚宝计划</a>
                <!-- <a  href="/Paas" >PaaS平台</a>
                <a  href="/Iaas" >IaaS 平台</a>
                <a  href="/jubao" >聚宝计划</a>-->
              </dd>
            </dl>
            <dl>
              <dt>关于</dt>
              <dd>
                <a @click="$router.push('/privacy')">用户注册协议</a>
                <!-- <a  href="/privacy" >用户注册协议</a>
                <a  href="/custody" >家长监管平台</a>
                <a  href="/dispute" >纠纷处理</a>-->
                <a @click="$router.push('/custody')">家长监管平台</a>
                <a @click="$router.push('/dispute')">纠纷处理</a>
              </dd>
            </dl>
          </div>
          <ul class="share-box clearfix">
            <li>
              <a href="javascript:;" class="iconS icon-wx"></a>
              <div class="code-show txt-show">敬请期待</div>
            </li>
            <li>
              <a href="javascript:;" class="iconS icon-qq"></a>
              <div class="code-show">
                <img src="~assets/img/qq_erweima.jpg" alt />
              </div>
            </li>
            <li>
              <a href="javascript:;" class="iconS icon-wb"></a>
              <div class="code-show txt-show">敬请期待</div>
            </li>
            <li>
              <a href="https://space.bilibili.com/411393226" target="_blank" class="iconS icon-bz"></a>
              <div class="code-show">
                <img src="~assets/img/bz_erweima.png" alt />
              </div>
            </li>
            <li>
              <a href="javascript:;" class="iconS icon-dy"></a>
              <div class="code-show">
                <img src="~assets/img/dy_erweima.jpg" alt />
              </div>
            </li>
            <li>
              <a href="javascript:;" class="iconS icon-ks"></a>
              <div class="code-show">
                <img src="~assets/img/ks_erweima.jpg" alt />
              </div>
            </li>
            <li>
              <a href="javascript:;" class="iconS icon-tap"></a>
              <div class="code-show txt-show">敬请期待</div>
            </li>
          </ul>
          <p style="font-size:12px;text-align:left">© 版权所有：深圳中青宝互动网络股份有限公司</p>
        </div>
        <div class="fl fm03">
          <p class="tel-txt">0755-26520977</p>
          <p class="time-txt">周一至周五 09:00-18:00</p>
          <!--<a href="javascript:;" class="btn-type03">在线咨询</a>-->
        </div>
      </div>
    </div>
    <div class="foot-sub">
      <div class="foot-box clearfix">
        <div class="small-logo">
          <span>
            <img src="~assets/img/police-9ecb5b55.png" alt />
          </span>
          <span>
            <img src="~assets/img/web_police.png" alt />
          </span>
          <span>
            <a
              href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44030502002829"
              target="_blank"
            >
              <img src="~assets/img/safe_examine.png" alt />
              <em>
                粤公网安备
                <br />44030502002829号
              </em>
            </a>
            <!-- <img src="~assets/img/safe_examine.png" alt /> -->
          </span>
        </div>
        <div class="foot-txt">
          <p>
            中华人民共和国增值电信业务经营许可证：粤B2-20030216
            <a
              href="https://beian.miit.gov.cn"
              target="_blank"
            >粤ICP备09057836号</a>
          </p>
          <!--<p>
            网络文化经营许可证：
            <a
              href="https://www.zqgame.com/v2/wculture.html"
              target="_blank"
            >粤网文〔2017〕6334-1548号</a>
            中华人民共和国互联网出版许可证：新出网证（粤）字029号
          </p>-->
        </div>
      </div>
    </div>
    <!-- <div class="lottie_json" @click="goOnline">
      <lottie
        :options="defaultOptions"
        :width="233"
        :height="66"
        v-on:animCreated="handleAnimation"
      />
    </div>-->
    <a href="javascript:;" class="backToTop">返回顶部</a>
  </div>
</template>
<script>
// import * as animationData from "@/assets/dataJson/data.json";
// animationData.assets.forEach((item, index) => {
//   item.u = "";
//   if (item.w && item.h) {
//     item.p = require(`@/assets/dataJson/images/${item.p}`);
//   }
// }); // 获取静态资源
export default {
  data() {
    return {
      // defaultOptions: { animationData: animationData.default },
      // animationSpeed: 1,
      // anim: {},
    };
  },
  methods: {
    // handleAnimation: function (anim) {
    //   this.anim = anim;
    //   console.log(anim); //这里可以看到 lottie 对象的全部属性
    // },
    // goOnline() {
    //   window.open("https://m.inmuu.com/v1/live/news/871366/intro");
    // },
  },
  mounted() {
    // 底部二维码显示隐藏
    $(".share-box li").hover(
      function () {
        $(this).children(".code-show").show();
      },
      function () {
        $(this).children(".code-show").hide();
      }
    );
  },
};
</script>
<style lang="scss">
#footer-content {
  color: rgba(255, 255, 255, 0.6);
  a {
    display: inline-block;
  }
  .backToTop {
    display: none;
    position: fixed;
    bottom: 40px;
    right: 40px;
    width: 44px;
    height: 44px;
    z-index: 99;
    text-indent: -9999px;
    background: url(~assets/img/main_bg.png) no-repeat -196px -76px;
  }
  .backToTop:hover {
    background-position: -196px -121px;
  }
  .backToTop:active {
    background-position: -196px -76px;
  }
  .lottie_json {
    width: 233px;
    height: 66px;
    position: fixed;
    z-index: 100;
    bottom: 30px;
    right: 114px;
    cursor: pointer;
  }
}
#footer-content a {
  color: rgba(255, 255, 255, 0.6);
}
#footer-content a:hover {
  color: #fff;
}
.foot-main {
  padding: 85px 0 80px;
  background: -webkit-linear-gradient(to top, #2d3e52, #27384c);
  background: linear-gradient(to top, #2d3e52, #27384c);
  background: -ms-linear-gradient(to top, #2d3e52, #27384c);
  background: -moz-linear-gradient(to top, to top, #2d3e52, #27384c);
  overflow: hidden;
}
.foot-box {
  // width: 1200px;
  margin: 0 auto;
  // display: flex;
  // justify-content: space-between;
  padding: 0 10px;
}
.foot-main .fm01 {
  width: 220px;
  margin-right: 110px;
}
.foot-main .fm02 {
  width: 420px;
}
.foot-main .fm03 {
  float: right;
  width: 240px;
  text-align: right;
}
.foot-logo {
  width: 206px;
  height: 58px;
  margin-bottom: 56px;
  background: url(~assets/img/foot_logo.png) no-repeat;
}
.foot-main .fm01 h5 {
  margin-bottom: 10px;
  color: #fff;
  font-size: 14px;
  line-height: 14px;
  letter-spacing: 0.4px;
  text-align: left;
}
.foot-main .fm01 p {
  line-height: 25px;
  // letter-spacing: 0.4px;
  letter-spacing: 1.4px;
  width: 216px;
  height: 100px;
  font-size: 14px;
}
.foot-menu {
  overflow: hidden;
}
.foot-menu dl {
  float: left;
  margin-right: 70px;
  text-align: left;
}
.foot-menu dl:last-child {
  margin-right: 0;
}
.foot-menu dt {
  margin-bottom: 25px;
  color: #fff;
  font-size: 16px;
  line-height: 16px;
  letter-spacing: 0.6px;
}
#footer-content .foot-menu dd a {
  display: block;
  font-size: 14px;
  line-height: 30px;
  letter-spacing: 0.4px;
}
.share-box {
  margin: 28px 0;
  height: 36px;
  // overflow: hidden;
}
.share-box li {
  position: relative;
  float: left;
  width: 36px;
  margin-right: 24px;
}

.share-box .code-show {
  position: absolute;
  bottom: 50px;
  left: -32px;
  display: none;
  width: 92px;
  color: #333;
  text-align: center;
  border: 4px solid #fff;
  border-radius: 5px;
  background: #fff;
  z-index: 10;
}
.share-box .code-show:before {
  content: "";
  position: absolute;
  bottom: -11px;
  left: 50%;
  width: 0;
  height: 0;
  margin-left: -6px;
  border-left: 7px solid transparent;
  border-right: 7px solid transparent;
  border-top: 7px solid #fff;
}
.share-box .code-show img {
  width: 92px;
  height: 92px;
}
.share-box .txt-show {
  font-size: 12px;
  bottom: 44px;
  left: -16px;
  width: 68px;
  color: #fff;
  line-height: 28px;
  border: none;
  background: linear-gradient(
    to top,
    rgba(112, 140, 178, 0.8),
    rgba(71, 90, 114, 0.8)
  );
  background: -ms-linear-gradient(
    to top,
    rgba(112, 140, 178, 0.8),
    rgba(71, 90, 114, 0.8)
  );
  background: -webkit-linear-gradient(
    to top,
    rgba(112, 140, 178, 0.8),
    rgba(71, 90, 114, 0.8)
  );
  background: -moz-linear-gradient(
    to top,
    to top,
    rgba(112, 140, 178, 0.8),
    rgba(71, 90, 114, 0.8)
  );
}
.share-box .txt-show:before {
  display: none;
}
.iconS {
  display: block;
  width: 36px;
  height: 36px;
  background: url(~assets/img/ico_share.png) no-repeat;
}
.icon-qq {
  background-position: -46px 0;
}
.icon-wb {
  background-position: -92px 0;
}
.icon-bz {
  background-position: -138px 0;
}
.icon-dy {
  background-position: -184px 0;
}
.icon-ks {
  background-position: -230px 0;
}
.icon-tap {
  background-position: -276px 0;
}
.icon-wx:hover {
  background-position: 0 -46px;
}
.icon-qq:hover {
  background-position: -46px -46px;
}
.icon-wb:hover {
  background-position: -92px -46px;
}
.icon-bz:hover {
  background-position: -138px -46px;
}
.icon-dy:hover {
  background-position: -184px -46px;
}
.icon-ks:hover {
  background-position: -230px -46px;
}
.icon-tap:hover {
  background-position: -276px -46px;
}
.tel-txt {
  color: #fff;
  font-size: 28px;
  line-height: 30px;
  letter-spacing: 1.8px;
}
.time-txt {
  margin: 16px 0 24px;
  font-size: 14px;
  letter-spacing: 0.4px;
}
#footer .btn-type03 {
  color: #fff;
  text-align: center;
}
.foot-sub {
  padding: 20px 0;
  background: #202e40;
  overflow: hidden;
  font-size: 12px;
}
.small-logo {
  float: left;
  margin-right: 70px;
  // padding-top: 10px;
}
.small-logo span {
  display: inline-block;
  margin-right: 20px;
  line-height: 20px;
  padding-top: 7px;
}
.small-logo img {
  width: 20px;
  height: 23px;
  vertical-align: middle;
  float: left;
}
.small-logo em {
  display: inline-block;
  font-size: 14px;
  vertical-align: middle;
  margin-top: -7px;
  margin-left: 12px;
}
.foot-logo li {
  float: left;
  margin: 10px 5px 0;
}
.foot-txt {
  float: left;
}

.foot-box {
  width: 1200px;
  margin: 0 auto;
}
</style>
